import React from 'react';
import { useState } from 'react';

export default function ChooseSearchMethodDropdown() {

  const [method, setMethod] = useState('search/');

  const handleChange = (event) => {
    setMethod(event.target.value);
  };

  return (
    <>
      <form className="flex flex-col items-center justify-center my-8 mx-4 sm:flex-row" action={`${method}`} role="search">
        <div className="flex mb-2 sm:mb-0">
          <input 
            className="w-[300px] h-[50px] rounded-lg bg-dark text-primary p-4 outline-primary sm:w-[375px] lg:w-[590px]"
            type="text"
            name="q"
            placeholder="Search"
          />
          <button
            className="w-[50px] h-[50px] bg-dark rounded-lg ml-2 hover:bg-dark/75 hover:text-white transition-all sm:mx-2"
            type="submit"
            aria-label="{{ _('Search') }}"
          >
            <img className="w-5 m-auto" src="/static/images/search.png" alt="Search icon"/>
          </button>
        </div>
        <select
            className="bg-dark rounded-lg h-[50px] w-[358px] p-4 flex justify-center sm:w-[130px] lg:w-[150px] text-primary"
            value={method}
            onChange={handleChange}
        >
          <option value="search/">All records</option>
          <option value="bli">Only BLI</option>
          <option value="itc">Only ITC</option>
          <option value="mp">Only MP</option>
          <option value="mst">Only MST</option>
          <option value="spr">Only SPR</option>
        </select>
      </form>
    </>
  );
}